module.exports = require('./dist/package/Rx');



//////////////////
// WEBPACK FOOTER
// ../node_modules/@reactivex/rxjs/index.js
// module id = 40
// module chunks = 0